module.exports = __webpack_public_path__ + "img/TechStablesPurebred_ua.d2f0b1df.webp";